export default __webpack_public_path__ + "static/media/back-points.73c76c98.png";